import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, EmptyState, Skeleton, Tabs } from "../components/ui";
import PostCard from "../components/social/PostCard";
import PostComposer from "../components/social/PostComposer";
import useMe from "../components/social/useMe";
import useInfinite from "../components/character/useInfinite";
import { useAuth } from "../context/AuthContext";
import { useI18n } from "../services/i18n";
import content from "../services/api-content";
import "../styles/content.css";

export default function Feed() {
  const navigate = useNavigate();
  const { isSuperUser } = useAuth();
  const { t } = useI18n();
  const me = useMe();
  const [tab, setTab] = useState("creator");
  const [cursorTick, setCursorTick] = useState(0);
  // useInfinite ใช้เลขหน้า -> แปลงเป็น cursor ที่ได้จากหน้าก่อน
  const cursors = React.useRef({ 1: undefined });
  const list = useInfinite(async (page) => {
    const r = await content.posts.list({ type: "post", cursor: cursors.current[page], ...(tab === "private" ? { userId: me?.id } : {}) });
    cursors.current[page + 1] = r.nextCursor;
    return { items: tab === "private" ? r.items.filter((p) => p.userId === me?.id) : r.items, hasMore: !!r.nextCursor };
  }, [tab, me?.id, cursorTick]);
  const reset = () => { cursors.current = { 1: undefined }; setCursorTick((n) => n + 1); };

  return (
    <div style={{ maxWidth: 680, margin: "0 auto" }}>
      <div className="page-head"><div><h1>{t("ฟีดโซเชียล")}</h1><p>โพสต์จากครีเอเตอร์และตัวละคร</p></div></div>
      <Tabs tabs={[{ value: "creator", label: t("ครีเอเตอร์ฟีด") }, { value: "private", label: t("ส่วนตัว") }, { value: "shorts", label: t("คลิปสั้น") }]} value={tab} onChange={(v) => (v === "shorts" ? navigate("/shorts") : (cursors.current = { 1: undefined }, setTab(v)))} />
      <div className="mt-16"><PostComposer type="post" collapsed onPosted={reset} /></div>
      <div className="stack mt-16">
        {list.error ? <EmptyState icon="⚠️" title="โหลดฟีดไม่สำเร็จ" action={<Button onClick={reset}>ลองใหม่</Button>}><span className="error-text">{list.error}</span></EmptyState>
          : list.loading ? Array.from({ length: 3 }, (_, i) => <Skeleton key={i} height={140} radius={16} />)
          : !list.items.length ? <EmptyState icon="📝" title={tab === "private" ? "คุณยังไม่มีโพสต์" : "ยังไม่มีโพสต์"} action={<Link className="btn" to="/">ดูตัวละครแนะนำ</Link>}>เป็นคนแรกที่โพสต์เรื่องราวสิ</EmptyState>
          : list.items.map((p) => <PostCard key={p.id} p={p} meId={me?.id} isSuper={isSuperUser} onDeleted={reset} />)}
        {list.hasMore ? <Button onClick={list.loadMore} disabled={list.more}>{list.more ? "กำลังโหลด..." : "โหลดเพิ่ม"}</Button> : null}
      </div>
    </div>
  );
}
